import React from 'react'

function Categories(){

    return(
        <>
            <div className="widget">
                <h5 className="sub-title">Categories</h5>
                
                <ul>
                    <li><a href="/">UI/UX Design</a></li>
                    <li><a href="/">Learning/Course</a></li>
                    <li><a href="/">Programming</a></li>
                </ul>
            </div>
        </>
    )

}

export default Categories